module.exports = __webpack_public_path__ + "static/media/team_work_cn03.49404c92.png";